const B = ({children}) => (
    <span className="font-bold">{children}</span>
)

export default B